export const RESET = "SETTINGS_RESET";
export const SET_FORM = "SETTINGS_SET_FORM";
export const SET_ERROR = "SETTINGS_SET_ERROR";
export const TOGGLE_LOADING = "SETTINGS_TOGGLE_LOADING";

export const SET_USER = "SETTINGS_SET_USER";
export const CLEAR_USER = "SETTINGS_CLEAR_USER";

export const SET_SITE_SETTINGS = "SET_SITE_SETTINGS";
